import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkmark--square",
  "use": "icon-checkmark--square-usage",
  "viewBox": "0 0 10 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 11\" id=\"icon-checkmark--square\"><path fill=\"#242424\" stroke=\"#242424\" d=\"M.5 1.048h9v9h-9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol